import React from 'react';
import "./DashServices.css"
import AddNewPermitDoc from "../../components/addNewPermitDoc/addNewPermitDoc";

function DashboardServicesForAdmin() {
    return (
        <div className="service-head-template-dash">
            <div className="service-inner-component-dash">
                <AddNewPermitDoc/>
            </div>
        </div>
    );
}

export default DashboardServicesForAdmin;

